import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { Tab, TabsButtonsProps } from '@/components/common/Tabs/types'
import { TabsButtons } from '@/components'

export const AnalyticsTabs: React.FC = () => {
    const { t } = useTranslation('translations')
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const config: Array<Omit<Tab, 'content'> & { path: string }> = useMemo(
        () => [
            {
                id: 'usageAndCost',
                label: t('analytics.tabs.buttons.usageAndCost'),
                path: '/analytics/usage-and-cost',
            },
            {
                id: 'benchmarking',
                label: t('analytics.tabs.buttons.benchmarking'),
                path: '/analytics/benchmarking',
            },
        ],
        [t]
    )

    const onChange = useCallback(
        (id: string) => {
            const obj = config.find((obj) => obj.id === id)

            if (obj) {
                void navigate({ to: obj.path })
            }
        },
        [config, navigate]
    )

    const tabs: TabsButtonsProps['tabs'] = config.map(
        ({ path: _path, ...tab }) => tab
    )
    const activeTab = config.find((obj) => obj.path === pathname)?.id ?? ''

    return (
        <div>
            <TabsButtons
                tabs={tabs}
                activeTabId={activeTab}
                onChange={onChange}
                className="grid h-full grid-rows-[auto,1fr]"
            />
        </div>
    )
}
